import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface RegisterProps {
  onToggle: () => void;
}

const Register = ({ onToggle }: RegisterProps) => {
  return (
    <Card className="w-full h-full flex flex-col justify-center">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl">Regisztráció</CardTitle>
        <CardDescription>Hozd létre a fiókodat</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="reg-email">Email</Label>
          <Input id="reg-email" type="email" placeholder="email@example.com" required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="reg-password">Jelszó</Label>
          <Input id="reg-password" type="password" required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="confirm-password">Jelszó megerősítése</Label>
          <Input id="confirm-password" type="password" required />
        </div>
      </CardContent>
      <CardFooter className="flex flex-col gap-4">
        <Button className="w-full">Regisztráció</Button>
        <Button variant="link" onClick={onToggle} className="text-primary">
          Már van fiókod? Lépj be!
        </Button>
      </CardFooter>
    </Card>
  );
};

export default Register;